import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import global_config from '@/../config.json'

const routes = [
  {
    path: '/:catchAll(.*)',
    name: 'All',
    redirect: '/language'
  },
  {
    path: '/language',
    name: 'LanguageSelection',
    component: () => import(/* webpackChunkName: "language" */ '../views/LanguageSelection/index.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/Chat/index.vue')
  },
  {
    path: '/disclaimer/:language',
    name: 'Disclaimer',
    component: () => import(/* webpackChunkName: "disclaimer" */ '../views/Disclaimer/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  try {
    const { language = null } = to.query
    const { default_language = null } = global_config
    const selected_language = store.state.i18n.socket_language

    let next_params = {}

    if (Object.keys(to.query).length > 0) {
      store.commit('ADD_SOCKET_ADDITIONAL_QUERY_PARAMS', to.query)
      Object.keys(to.query).forEach((query) => {
        delete to.query[query]
      })
      next_params = { ...to, query: { ...to.query } }
    }

    if (to === from) return // Avoid redirect to same page
    else if (from.name === 'Chat') return // Avoid user back to previous page from home page
    else if (to.name === 'Chat' && from.name !== 'LanguageSelection' && !selected_language) next_params = { path: '/language' } // Avoid user access chat page directly

    store.commit('SET_I18N_LANGUAGE', language || selected_language || default_language)
    if ((language || default_language) && to.name === 'LanguageSelection') next_params = { path: '/chat' }
    if (JSON.stringify(next_params) === '{}') next()
    else next(next_params)
  } catch (error) {
    console.log(`Route Error: ${error.message}`)
  }
})

export default router
